// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

:root {
  --basal: #19A0D7;
  --basal-automated: #00B2C3;
  --bolus: #7CD0F0;
  --preset: #758CFF;
  --bolus-automated: #00B2C3;
  --bolus--interrupted: #FF8B7C;
  --bolus--ride: #107EA8;
  --bolus--undelivered: #BCECFA;
  --carbs: #F8D48E;
  --collapsible--border: #EDEDED;
  --table-stripe--light: #F7F7F7;
  --table-stripe--dark: #ECECEC;
  --trends--light: #D0D0D0;
  --trends--light--faded: #F0F0F0;
  --trends--dark: #BCBCBC;
  --trends--dark--faded: #E3E3E3;
  --input--border: #75849f;
  --input--disabled: #75849f;
  --stat--border: #75849f;
  --stat--default: #727375;
  --stat-disabled: #e7e9ee;
  --stat--dark: #27385b;
  --axis-tick: #E7E7E7;
  --bkgrnd: #F8F8F8;
  --bkgrnd-lines: #E7E7E7;
  --bkgrnd-white: #FFFFFF;
  --tooltip-title-bg: #EAEAEE;
  --chrome: #989897;
  --text-medium-contrast: #727375;
  --text-high-contrast: #281946;
  --text-black: #000000;
  --bg-very-low: #FB5951;
  --bg-low: #FF8B7C;
  --bg-target: #76D3A6;
  --bg-high: #BB9AE7;
  --bg-very-high: #8c65d6;
  --text-hover: #00D3D9;
  --blue-green-light: #12D3D8;
  --gray-medium: #989897;
  --gray-dark: #4E4E4F;
  --white: #FFFFFF;
  --brand-purple: #627CFF;
  --brand-purple-dark: #281946;
}
`, "",{"version":3,"sources":["webpack://./src/styles/colors.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n:root {\n  --basal: #19A0D7;\n  --basal-automated: #00B2C3;\n  --bolus: #7CD0F0;\n  --preset: #758CFF;\n  --bolus-automated: #00B2C3;\n  --bolus--interrupted: #FF8B7C;\n  --bolus--ride: #107EA8;\n  --bolus--undelivered: #BCECFA;\n  --carbs: #F8D48E;\n  --collapsible--border: #EDEDED;\n  --table-stripe--light: #F7F7F7;\n  --table-stripe--dark: #ECECEC;\n  --trends--light: #D0D0D0;\n  --trends--light--faded: #F0F0F0;\n  --trends--dark: #BCBCBC;\n  --trends--dark--faded: #E3E3E3;\n  --input--border: #75849f;\n  --input--disabled: #75849f;\n  --stat--border: #75849f;\n  --stat--default: #727375;\n  --stat-disabled: #e7e9ee;\n  --stat--dark: #27385b;\n  --axis-tick: #E7E7E7;\n  --bkgrnd: #F8F8F8;\n  --bkgrnd-lines: #E7E7E7;\n  --bkgrnd-white: #FFFFFF;\n  --tooltip-title-bg: #EAEAEE;\n  --chrome: #989897;\n  --text-medium-contrast: #727375;\n  --text-high-contrast: #281946;\n  --text-black: #000000;\n  --bg-very-low: #FB5951;\n  --bg-low: #FF8B7C;\n  --bg-target: #76D3A6;\n  --bg-high: #BB9AE7;\n  --bg-very-high: #8c65d6;\n  --text-hover: #00D3D9;\n  --blue-green-light: #12D3D8;\n  --gray-medium: #989897;\n  --gray-dark: #4E4E4F;\n  --white: #FFFFFF;\n  --brand-purple: #627CFF;\n  --brand-purple-dark: #281946;\n}\n\n:export {\n  bolus: #7CD0F0;\n  bolusAutomated: #00B2C3;\n  basal: #19A0D7;\n  basalAutomated: #00B2C3;\n  sleep: #4457D9;\n  preset: #758CFF;\n  physicalActivity: #758CFF;\n  preprandial: #4457D9;\n  statDark: #27385b;\n  statDefault: #727375;\n  statDisabled: #e7e9ee;\n  veryLow: #fb5951;\n  low: #FF8B7C;\n  target: #76D3A6;\n  high: #BB9AE7;\n  veryHigh: #8c65d6;\n  insulin: #0096d1;\n  white: #ffffff;\n  axis: #e7e9ee;\n  muted: #c1c9d6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bolus": `#7CD0F0`,
	"bolusAutomated": `#00B2C3`,
	"basal": `#19A0D7`,
	"basalAutomated": `#00B2C3`,
	"sleep": `#4457D9`,
	"preset": `#758CFF`,
	"physicalActivity": `#758CFF`,
	"preprandial": `#4457D9`,
	"statDark": `#27385b`,
	"statDefault": `#727375`,
	"statDisabled": `#e7e9ee`,
	"veryLow": `#fb5951`,
	"low": `#FF8B7C`,
	"target": `#76D3A6`,
	"high": `#BB9AE7`,
	"veryHigh": `#8c65d6`,
	"insulin": `#0096d1`,
	"white": `#ffffff`,
	"axis": `#e7e9ee`,
	"muted": `#c1c9d6`
};
export default ___CSS_LOADER_EXPORT___;
